import React from "react";
import {
  BatteryFull,
  BatteryLow,
  BatteryMedium,
  BatteryWarning,
} from "lucide-react";

interface BatteryIndicatorProps {
  batteryPercent: number;
}

const BatteryIndicator: React.FC<BatteryIndicatorProps> = ({
  batteryPercent,
}) => {
  return (
    <div className="flex items-center gap-1.5">
      {batteryPercent > 60 ? (
        <BatteryFull className="w-4 h-4 text-green-500" />
      ) : batteryPercent > 30 ? (
        <BatteryMedium className="w-4 h-4 text-yellow-500" />
      ) : batteryPercent > 10 ? (
        <BatteryLow className="w-4 h-4 text-orange-500" />
      ) : (
        <BatteryWarning className="w-4 h-4 text-red-500" />
      )}
      <span
        className={`text-xs font-medium ${
          batteryPercent > 60
            ? "text-green-600"
            : batteryPercent > 30
            ? "text-yellow-600"
            : batteryPercent > 10
            ? "text-orange-600"
            : "text-red-600"
        }`}
      >
        {batteryPercent}%
      </span>
    </div>
  );
};

export default BatteryIndicator;
